import React from 'react'
import Moment from 'react-moment'
import { lower } from 'change-case'

import { StatusTag } from 'components'
import { numberFormat } from './helper'

import { DivText } from './styled'

export const pouStatus = {0:'Draft',1:'New',2:'In Progress',3:'Revise',4:'Completed',5:'Reject',6:'Cancelled'}

export const columns = { 
  tPOUs:[
    {
      Header: 'PR No.',
      accessor: 'documentNumber',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },
    {
      Header: ()=>(<DivText left>Title</DivText>),
      accessor : row =>(row.title.trim()),
      id:'title',
    }, 
    {
      Header: 'Priority',
      accessor: 'priority',
      width: 70,
      Cell: row => (
        row.value && 
        <DivText><div className={`priority ${row.value}`}>{row.value.toUpperCase()}</div></DivText>)
    },
    {
      Header: ()=>(<DivText left>Project name</DivText>),
      accessor: 'projectName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },
    {
      Header: ()=>(<DivText left>Requester</DivText>),
      accessor: 'requesterName',
      width: 100,
      Cell: row => (row.value&&<DivText left>{`${row.value||'-'}`}</DivText>)
    },
    {
      Header: 'Company',
      accessor : 'companyName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },
    {
      Header: 'Current Process',
      accessor: 'currencyProcess',
      width: 180,
      Cell:row=>(<DivText>{row.value}</DivText>)
    }
  ],

  tPOItem:[
    {
      Header: 'No',
      accessor: 'lineNo',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Material No.',
      accessor: 'materialNo',
      width: 120,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Item Name',
      accessor: 'itemName',
      width: 100,
    },
    {
      Header: 'Description',
      accessor: 'itemDescription',
    },
    {
      Header: 'Quantity',
      accessor: 'sapQtyRemain',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value,false,3)}</DivText>)
    },
    {
      Header: 'Unit Price',
      accessor : 'netPrice',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value)}</DivText>)
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Amount',
      accessor: 'sapAmount',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value)}</DivText>)
    },
  ]
}